import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ConfigurationProfilesDialogsService} from "../../services/configuration-profiles-dialogs-service.service";
import {ConfigurationProfilesService} from "../../services/configuration-profiles-service.service";
import {AccountModel} from "../../../account/angular/models/account.model";

export class configurationProfileViewCtrl implements IController {

  configurationProfile: any;
  account: AccountModel;
  accounts: any;
  defaultProfileId: any;
  selectedTab: string;
  isAccountProfile: boolean;

  private isMobile: boolean;
  private profileCopy: any;
  private isFooterDisplayed: boolean;
  private isCardExpanded: any;
  public accountIds: string[];

  /* @ngInject */
  constructor(private configurationProfilesService: ConfigurationProfilesService, private $state, private configurationProfilesDialogsService: ConfigurationProfilesDialogsService,
              private $mdMedia) {
  }

  $onInit() {
    this.isMobile = !this.$mdMedia('gt-md');
    this.accountIds = this.accounts.map((account) => account.id);
    this.isCardExpanded = {
      autoAssignPreferences: false,
      autoAssignFiltersCourierFilters: false,
      autoAssignScoreFactors: false,
      manualAssignFiltersCourierFilters: false,
      // manualAssignScoreFactors: false,
      auctionPreferences: false,
      auctionCourierFilters: false,
      auctionScoreFactors: false
    }
    this.isFooterDisplayed = false;
    this.profileCopy = angular.copy(this.configurationProfile);
  }

  $onChanges(changes) {
    if (changes.account && !changes.account.isFirstChange()) {
      this.account = changes.account.currentValue;
      this.configurationProfile = changes.account.accountConfigurationProfile;
    }
  }

  onUpdateInfo(profile, event) {
    this.isAccountProfile ? this.onUpdateAccountProfileInfo(profile, event) : this.onUpdateProfileInfo(profile, event);

  }

  onUpdateProfileInfo(profile, event) {
    this.configurationProfilesDialogsService.editProfileInfo(profile, this.accountIds, event)
      .then((payload) => {
        if (!_.isEqual(this.accountIds, payload.accountIds)) {
          const accountIdsRemoved = _.difference(this.accountIds, payload.accountIds);
          if (accountIdsRemoved.length) {
            this.onAssignAccountsToDefaultProfile(accountIdsRemoved);
          }
          if (payload.accountIds.length) {
            this.onAssignAccountsToProfile(profile.id, payload.accountIds, false);
          }
        }
        if (!_.isEqual(this.configurationProfile, payload.updatedProfile)) {
          this.onUpdateProfile(payload.updatedProfile);
        }
      })
  }

  onUpdateAccountProfileInfo(profile, event) {
    this.configurationProfilesDialogsService.editProfileInfo(profile, undefined, event, this.account)
      .then((payload) => {
        if (!_.isEqual(this.configurationProfile, payload.updatedProfile)) {
          this.onUpdateAccountProfile(payload.updatedProfile);
        }
      })
  }

  onChangePercentage(value, group, subGroup, property) {
    if (!this.profileCopy[group]) {
      this.profileCopy[group] = {};
    }

    if (!this.profileCopy[group][subGroup]) {
      this.profileCopy[group][subGroup] = {};
    }

    _.set(this.profileCopy[group][subGroup], property, value);
    this.onEditItem();
  }

  onEditItem() {
    if (!_.isEqual(this.configurationProfile, this.profileCopy)) {
      this.isFooterDisplayed = true;
    }
  }

  onSave(profile, event) {
    this.isAccountProfile ? this.onUpdateAccountProfileInfo(profile, event) : this.onUpdateProfile(profile);
  }

  onUpdateProfile(profile) {
    this.configurationProfilesService.updateOne(profile)
      .then((updatedProfile) => {
        this.configurationProfile = updatedProfile;
        this.$onInit();
      })
  }

  onUpdateAccountProfile(profile) {
    this.configurationProfilesService.updateAccountProfile(profile, this.account.id)
      .then((updatedAccount: any) => {
        this.account = updatedAccount;
        this.configurationProfile = updatedAccount.accountConfigurationProfile;

        this.$onInit();
      })
  }

  onAssignAccountsToProfile(profileId, accountIds, isDuplicated) {
    this.configurationProfilesService.assignAccountsToProfile(profileId, accountIds)
      .then((accounts: AccountModel[]) => {
        const accountsRef = angular.copy(accounts);
        this.accountIds = _.map(accountsRef, (account: AccountModel) => {
          return account.id;
        });
      }).then(() => {
      if (isDuplicated) {
        this.$state.go('site-administration.configuration-profile', {id: profileId});
      }
    })
  }

  onAssignAccountsToDefaultProfile(accountIds) {
    this.configurationProfilesService.assignAccountsToProfile(this.defaultProfileId, accountIds)
      .then((accounts) => {
        this.$onInit();
      })
  }

  onCancelUpdateProfile() {
    this.profileCopy = angular.copy(this.configurationProfile);
    this.isFooterDisplayed = false;
  }

  onDelete(profileId) {
    this.configurationProfilesService.deleteOne(profileId)
      .then((removedProfile) => {
        this.$state.go('site-administration.configuration-profiles');
      })
  }

  onDuplicate(configurationProfile, event) {
    this.configurationProfilesDialogsService.createProfileInfo(configurationProfile, event, true)
      .then((payload) => {
        this._onDuplicate(payload.newProfile, payload.accountIds);
      })
  }

  // ******************************
  //        Private methods
  // ******************************

  private _onDuplicate(profile, accountIds) {
    _.unset(profile, 'id');
    this.configurationProfilesService.duplicateOne(profile)
      .then((duplicatedProfile: any) => {
        if (accountIds.length) {
          this.onAssignAccountsToProfile(duplicatedProfile.id, accountIds, true);
        }
      })
  }

}

angular
  .module('bringoz.admin.configuration-profiles')
  .component('configurationProfileView', {
    bindings: {
      configurationProfile: '<',
      account: '<?',
      accounts: '<?',
      defaultProfileId: '<?',
      selectedTab: '<',
      isAccountProfile: '<?'
    },
    template: require('./configuration-profile-view.html').default,
    controller: configurationProfileViewCtrl
  });
